import React, { useState, useEffect } from 'react'

import { connect, mapStateToProps, mapDispatchToProps, cookies } from '../../helpers/Common'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboardList, faPlay } from '@fortawesome/free-solid-svg-icons'
import { useLocation } from 'react-router-dom'
import { LangAlertTR, LangAlertTR2, LangStart, LangViewStatus, LangFillIn } from '../../constant/languange'

const TourGuideAlert = ({ redux, setState, type = 'common' }) => {
  const location = useLocation()

  // state
  const [progress, setProgress] = useState(0)
  const [showAlert, setShowAlert] = useState(false)

  // effect
  useEffect(() => {
    setTimeout(() => {
      setShowAlert(!redux.isStopTour)
    }, 2000)
  }, [redux.isStopTour])

  useEffect(() => {
    if (redux.stats) {
      const statValues = Object.values(redux.stats)

      // progress bar
      setProgress(statValues.filter(value => value > 0).length)
    }
  }, [redux.stats])

  // handler
  const setOpenIndicator = () => {
    setState({ openIndicator: true })
  }

  return (
    <>
      {showAlert && !redux.profile.supervisor_groups && !+cookies.get(`clickFinish-${redux.profile.id}`)
        ? (
          <>
            {type === 'common' && location.pathname !== '/dashboard' && !!+cookies.get(`showAlertProgress-${redux.profile.id}`) && !redux.isTemporary && (
              <div className='container-fluid pt-3'>
                <div style={{ background: '#FFE8BA', borderRadius: '10px', padding: '8px 12px 8px 16px' }} className='d-flex align-items-center'>
                  <p style={{ fontWeight: '500', fontSize: '14px' }} className='text-dark mb-0 mr-2 text-truncate'>{LangAlertTR2}</p>
                  {/* progress bar mini */}
                  <div className='rounded-pill d-none d-sm-block flex-shrink-0 mr-2' style={{ background: 'rgba(0, 0, 0, .1)', width: '80px', height: '6px', overflow: 'hidden' }}>
                    <div className='rounded-pill' style={{ background: '#25A091', width: `${Math.ceil(progress / 6 * 100)}%`, height: '6px' }} />
                  </div>
                  <span className='text-dark flex-shrink-0 mr-3' style={{ fontWeight: '700', fontSize: '14px' }}>{Math.ceil(progress / 6 * 100)}%</span>
                  <button onClick={() => { setOpenIndicator() }} className='btn btn-sm rounded-pill btn-primary d-flex flex-nowrap align-items-center text-white ml-auto flex-shrink-0'><FontAwesomeIcon className='mr-1' icon={faClipboardList} /> {progress === 6 ? LangViewStatus : LangFillIn}</button>
                </div>
              </div>
            )}

            {type === 'dashboard' && progress < 6  && !redux.isTemporary && redux.profile.role_id !== 4 && (
              <div className='mb-3'>
                <div style={{ background: '#FFE8BA', borderRadius: '10px', padding: '8px 12px 8px 16px' }} className='d-flex align-items-center'>
                  <div className='loader-box flex-shrink-0 mr-2' style={{ height: 'auto' }}>
                    <div className='loader-9 bg-danger' style={{ width: 12, height: 12 }} />
                  </div>
                  <p style={{ fontWeight: '500', fontSize: '14px', lineHeight: '20px' }} className='text-dark mb-0 mr-3'>
                    {LangAlertTR}
                  </p>
                  <button onClick={() => { setOpenIndicator() }} className='btn btn-sm rounded-pill btn-primary d-flex flex-nowrap align-items-center text-white ml-auto flex-shrink-0'><FontAwesomeIcon className='mr-1' icon={faPlay} /> {LangStart}</button>
                </div>
              </div>
            )}
          </>
          )
        : ''}
    </>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(TourGuideAlert)
